import { language } from '@tencent/ppd-base-libs';

// 获取语言标示
export function getLang() {
  let lang = language.getLanguage();
  lang = lang.replace(/-/g, '_');
  if (lang !== 'en' && lang !== 'zh_hk') {
    return 'zh_hk';
  }
  return lang;
}
// 数据拷贝
export function copyData(data) {
  return JSON.parse(JSON.stringify(data));
}
// 各位数字前面补零
function fillNumber(num) {
  const str = num.toString();
  return str.length <= 1 ? `0${str}` : str;
}
// 格式化时间字符串，如：2020-02-18 22:30
export function formatDate(time) {
  if (time instanceof Date) {
    const obj = {
      year: time.getFullYear(),
      month: fillNumber(time.getMonth() + 1),
      date: fillNumber(time.getDate()),
      hour: fillNumber(time.getHours()),
      minute: fillNumber(time.getMinutes()),
    };
    return `${obj.year}-${obj.month}-${obj.date} ${obj.hour}:${obj.minute}`;
  }
  return '';
}

// 将vtools中配置的中文时间自动转为英文格式
export function autoEnDate(zhDate: string) {
  const enMonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const time = (zhDate || '').replace(/香港時間|分|日/g, '').replace(/年|月/g, '/')
    .replace(/時/g, ':');
  const reg = /^[1-9]\d{3}\/([1-9]|1[0-2])\/([1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d$/g;
  if (reg.test(time)) {
    const stamp = new Date(time);
    const enDate = `${enMonthList[stamp.getMonth()]} ${stamp.getDate()}, ${stamp.getFullYear()} Issued at HKT ${fillNumber(stamp.getHours())}:${fillNumber(stamp.getMinutes())}`;
    return enDate;
  }
  return zhDate;
}

// 新增疫情数字加减展示
export function diff_filter(num) {
  const value = parseInt(num, 10);
  if (value === 0 || Number.isNaN(value)) return '+0';
  if (value > 0) return `+${value}`;
  return value;
};

// 千分位
export function thousands(num) {
  const value = parseInt(num, 10) || 0;
  const pn = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
  if (Number.isNaN(value)) {
    return '-';
  }
  return value <= 0 ? '0' : value.toString().replace(pn, '$1,');
}
// 数字为0，增加--掩码
export function maskZero(num) {
  const value = parseInt(num, 10);
  if (Number.isNaN(value) || value === 0) {
    return '-';
  }
  return value.toString();
}
